<template>
  <div v-if="filter.type === 'single' || filter.type === 'multiple'">
    <v-select
      :options="paginated"
      :filterable="false"
      :searchable="allowTextInput"
      :placeholder="filter.name | translate | capitalize"
      :multiple="filter.type === 'multiple'"
      v-model="filter.model"
      @input="onInput()"
      @open="onOpen"
      @close="onClose"
      @search="query => (this.search = query)"
      class="filter"
    >
      <template #option="{label}">{{
        (filter.translate ? $t(`filter.${filter.key}.${label}`) : label)
          | capitalize
      }}</template>
      <template #selected-option="{label}">{{
        (filter.translate ? $t(`filter.${filter.key}.${label}`) : label)
          | capitalize
      }}</template>
      <template #no-options="{ search }">
        {{
          (search
            ? "filter.messages.no_matching_results_found"
            : "filter.messages.no_keys_found") | translate
        }}
      </template>
      <template #list-footer v-if="hasNextPage">
        <li ref="load" class="loader">
          {{ "filter.messages.loading_more" | translate }}
        </li>
      </template>
    </v-select>
  </div>
  <div v-else-if="filter.type === 'range'">
    <b-dropdown
      class="slider-dropdown"
      :text="displayPlaceholderOrRange"
      menu-class="w-100"
    >
      <div class="icon-container">
        <BIconX class="close-icon" @click="resetRange" />
      </div>
      <vue-slider
        v-model="filter.model"
        class="slider"
        :min="priceRange[0]"
        :max="priceRange[1]"
        :interval="10"
        :lazy="true"
        :enable-cross="false"
        @change="onChange"
      />
      <p class="price-range">{{ displayRange(filter.model) }}</p>
    </b-dropdown>
  </div>
  <div v-else></div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { BIconX } from "bootstrap-vue";
import { PRICE_RANGE } from "../../constants";
export default {
  name: "gyra-filter",
  components: {
    VueSlider,
    BIconX
  },
  data() {
    return {
      search: "",
      limit: 10,
      observer: new IntersectionObserver(this.infiniteScroll),
      valueSet: false,
      priceRange: PRICE_RANGE
    };
  },
  props: {
    filter: { required: true, type: Object },
    allowTextInput: { required: false, default: true }
  },
  methods: {
    onInput() {
      this.$emit("input");
      if (this.$cookies.get("accept-cookie-policy")) {
        this.$gtag.event("filterSelected", {
          value: this.filter.name.replace("filter.title.", ""),
          event_label: "product",
          event_category: "filter"
        });
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 10;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    displayRange(rangeList) {
      return `${this.$n(+rangeList[0], "EUR")} - ${this.$n(
        +rangeList[1],
        "EUR"
      )}`;
    },
    onChange() {
      if (this.$cookies.get("accept-cookie-policy")) {
        this.$gtag.event("filterSelected", {
          value: this.filter.name.replace("filter.title.", ""),
          event_label: "product",
          event_category: "filter"
        });
      }
      this.valueSet = true;
      this.$emit("input");
    },
    resetRange() {
      this.valueSet = false;
      this.filter.model = PRICE_RANGE;
      this.$emit("input");
    }
  },
  computed: {
    filtered() {
      return this.filter.options.filter(
        option => option && option.includes(this.search)
      );
    },
    paginated() {
      return this.filtered.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length;
    },
    displayPlaceholderOrRange() {
      return this.valueSet
        ? this.displayRange(this.filter.model)
        : this.$t(this.filter.name);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.slider {
  margin: 46px 32px 16px;
}
.price-range {
  margin-left: 16px;
  margin-right: 16px;
  font-size: 14px;
}
.slider-dropdown {
  width: 100%;
  height: 34.4px;
}
.icon-container {
  width: 100%;
  display: flex;
  justify-content: right;
}
.close-icon {
  cursor: pointer;
  margin-right: 16px;
  font-size: 1rem;
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.slider-dropdown {
  button {
    background-color: white !important;
    color: $gyra-grey-light !important;
    font-size: 14px;
    text-align: left;
  }
}
</style>
